<template>
    <div>
        <ul class="pagination">
            <li class="pagination-item">
                <button class="pagination-button" @click="onClickFirstPage" :disabled="isInFirstPage"><img src="@/assets/images/arrow-prev-page.svg"></button>
            </li>
            <li class="pagination-item">
                <button class="pagination-button" @click="onClickPreviousPage" :disabled="isInFirstPage"><img src="@/assets/images/arrow-prev.svg"></button>
            </li>

            <li v-for="page in pages" :key="page.name" class="pagination-item">
                <button class="pagination-button pagination-text" @click="onClickPage(page.name)" :disabled="page.isDidabled" :class="{ active: isPageActive(page.name) }">{{ page.name }}</button>
            </li>

            <li class="pagination-item">
                <button class="pagination-button" @click="onClickNextPage" :disabled="isInLastPage"><img src="@/assets/images/arrow-nxt.svg"></button>
            </li>
            <li class="pagination-item">
                <button class="pagination-button" @click="onClickLastPage" :disabled="isInLastPage"><img src="@/assets/images/arrow-nxt-page.svg"></button>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        maxVisibleButtons: {
            type: Number,
            required: false,
            default: 7
        },
        totalPages: {
            type: Number,
            required: true
        },
        perPage: {
            type: Number,
            required: true
        },
        currentPage: {
            type: Number,
            required: true
        },
    },
    computed: {
        startPage() {
            if (this.currentPage === 1 || this.currentPage === 2) {
                return 1;
            }
            if (this.currentPage === this.totalPages) {
                return this.totalPages - this.maxVisibleButtons + 1;
            }
            return this.currentPage - 2;
        },
        pages() {
            const range = [];
            for (let i = (this.startPage); i <= Math.min(this.startPage + this.maxVisibleButtons, this.totalPages); i++) {
                range.push({
                    name: i,
                    isDisabled: i === this.currentPage
                });
            }
            return range;
        },
        isInFirstPage() {
            return this.currentPage === 1;
        },
        isInLastPage() {
            return this.currentPage === this.totalPages;
        },
    },
    methods: {
        onClickFirstPage() {
            if (!this.isInFirstPage) {
                this.$emit('pagechanged', 1);
                this.scrollToElement();
            }
        },
        onClickPreviousPage() {
            if (!this.isInFirstPage) {
                this.$emit('pagechanged', this.currentPage - 1);
                this.scrollToElement();
            }
        },
        onClickPage(page) {
            this.$emit('pagechanged', page);
            this.scrollToElement();
        },
        onClickNextPage() {
            if (!this.isInLastPage) {
                this.$emit('pagechanged', this.currentPage + 1);
                this.scrollToElement();
            }
        },
        onClickLastPage() {
            if (!this.isInLastPage) {
                this.$emit('pagechanged', this.totalPages);
                this.scrollToElement();
            }
        },
        isPageActive(page) {
            return this.currentPage === page;
        },
        scrollToElement() {
            const container = document.getElementById('result-bloc');
            container.scrollIntoView({ behavior: 'smooth', block: "center" });
        }
    }
}
</script>

<style lang="scss">
@import "@/scss/helpers/mixins";
@import "@/scss/helpers/variables";

.pagination {
    padding: 0;
    margin: 0;
    list-style-type: none;
    display: flex;
    align-items: center;
    justify-content: center;
}

.pagination-button {
    padding: 0;
    margin: 0 5px;
    border: none;
    background: none;
    cursor: pointer;
    @include transition-custom;

    &:hover, &:focus {
        opacity: .5;
    }
}

.pagination-text {
    font-family: $campaign;
    font-size: 13px;
    font-weight: $bold;
    line-height: 13px;
    opacity: 0.3;
    color: $main;

    &.active {
        opacity: 1;
    }
}

.pagination-item {
    display: flex;
    align-items: center;
}
</style>